import {
  TKeywordMarker,
  ZLandmarkMarker,
  ZLocationMarkerType,
  ZRegionMarker,
  ZSubwayMarker,
} from '@/entities/map'

import { History } from '../model/search-history-store/history'
import { TLocation } from '../model/selected-location'

export const getLocationName = (location: TKeywordMarker | null) => {
  if (!location) return ''

  if ('fullName' in location) {
    return location.fullName
  }

  return location.name
}

export const convertMarkerToLocation = (location: TKeywordMarker | null) => {
  if (!location) return null

  const type = (() => {
    if (ZSubwayMarker.safeParse(location).success) {
      return ZLocationMarkerType.Enum.SUBWAY
    }

    if (ZRegionMarker.safeParse(location).success) {
      return ZLocationMarkerType.Enum.REGION
    }

    if (ZLandmarkMarker.safeParse(location).success) {
      return ZLocationMarkerType.Enum.LANDMARK
    }

    return null
  })()

  if (!type) return null

  return {
    name: getLocationName(location),
    keyword: location.name,
    type,
    lat: location.lat,
    lng: location.lng,
    nextZoomLevel: location.nextZoomLevel,
    subwayLines: 'subwayLines' in location ? location.subwayLines : null,
  }
}

export const convertHistoryToLocation = (history: History) => {
  return {
    name: history.name,
    keyword: history.keyword,
    type: history.type,
    lat: history.location?.lat || null,
    lng: history.location?.lng || null,
    nextZoomLevel: history.nextZoomLevel,
    subwayLines: history.subwayLines,
  } as TLocation
}
